module.exports = __webpack_public_path__ + "img/logo_footer.d7f5a07e.png";